import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { LifeBuoy, MessageCircle, Ticket, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

const SCREEN_LABELS = {
  "/owner": "Central", "/owner/ordens": "Ordens", "/owner/customers": "Clientes", "/owner/patio": "Pátio",
  "/owner/financeiro": "Financeiro", "/owner/settings": "Configurações", "/owner/dashboard": "Painel",
  "/owner/balcao": "Venda balcão", "/owner/estoque": "Estoque", "/owner/suporte": "Suporte",
  "/owner/pacotes": "Pacotes adicionais", "/owner/nova-ordem": "Nova ordem",
};

function screenLabel(path) {
  for (const k of Object.keys(SCREEN_LABELS)) if (path === k || path.startsWith(k + "/")) return SCREEN_LABELS[k];
  return path;
}

export function SupportMenu() {
  const { user } = useAuth();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(null);
  const ref = useRef(null);
  useEffect(() => {
    if (!user || user.shop_id === "all" || user.role !== "owner") return;
    api.get("/support/info").then(({ data }) => setInfo(data)).catch(() => {});
  }, [user?.id, user?.shop_id]);
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  if (!user || user.role !== "owner") return null;
  const phone = (info?.support_whatsapp || "").replace(/\D/g, "");
  const text = encodeURIComponent(`Olá! Sou ${info?.user_name || user?.name || "dono"} da ${info?.shop_name || "oficina"}. Preciso de ajuda em "${screenLabel(loc.pathname)}".`);
  const waHref = phone ? `https://wa.me/${phone}?text=${text}` : null;
  return (
    <div ref={ref} className="relative">
      <button type="button" data-testid="support-menu-btn" onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 h-9 px-2.5 rounded-md text-[13px] font-semibold text-zinc-300 hover:text-zinc-100 hover:bg-zinc-900">
        <LifeBuoy className="h-4 w-4" /> <span className="hidden sm:inline">Suporte</span> <ChevronDown className={cn("h-3.5 w-3.5 transition-transform", open && "rotate-180")} />
      </button>
      {open && (
        <div data-testid="support-menu" className="absolute right-0 top-full mt-1 z-50 min-w-[14rem] rounded-xl border border-zinc-800 bg-zinc-950 shadow-2xl p-1.5">
          {waHref ? (
            <a data-testid="support-wa" href={waHref} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}
               className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-zinc-200 hover:bg-zinc-900 hover:text-emerald-300">
              <MessageCircle className="h-4 w-4" /> Falar no WhatsApp
            </a>
          ) : (
            <div className="px-3 py-2 text-[11px] text-zinc-500">WhatsApp do suporte não configurado</div>
          )}
          <Link data-testid="support-tickets" to="/owner/suporte" onClick={() => setOpen(false)}
                className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-zinc-200 hover:bg-zinc-900 hover:text-zinc-100">
            <Ticket className="h-4 w-4" /> Abrir chamado
          </Link>
        </div>
      )}
    </div>
  );
}
